import { render, staticRenderFns } from "./batch-dialog.vue?vue&type=template&id=0f65deaa&"
import script from "./batch-dialog.vue?vue&type=script&lang=js&"
export * from "./batch-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports